import React from 'react';
import { useTranslation } from 'react-i18next';
import { GameState } from '../core/types';
import { ENERGY_MAX } from '../core/energy';
import LanguageToggle from './LanguageToggle';

interface Props {
  gameState: GameState;
  energy: number;
}

const TopBar: React.FC<Props> = ({ gameState, energy }) => {
  const { t } = useTranslation();

  return (
    <div className="top-bar">
      <div className="day-info">{t('topbar.day', { day: gameState.currentDay })}</div>
      <div className="quota-info">{t('topbar.progress', { done: gameState.processedToday, total: gameState.dailyQuota })}</div>
      <div className="status-indicators">
        <span className="indicator kpi">
          <span className="indicator-label">KPI</span>
          <span className="indicator-value">{gameState.kpi}</span>
        </span>
        <span className={`indicator ${gameState.careerRisk >= 70 ? 'danger' : gameState.careerRisk >= 40 ? 'warning' : ''}`}>
          <span className="indicator-label">{t('topbar.careerRisk')}</span>
          <span className="indicator-value">{gameState.careerRisk}</span>
        </span>
        <span className={`indicator ${gameState.proceduralRisk >= 70 ? 'danger' : gameState.proceduralRisk >= 40 ? 'warning' : ''}`}>
          <span className="indicator-label">{t('topbar.proceduralRisk')}</span>
          <span className="indicator-value">{gameState.proceduralRisk}</span>
        </span>
      </div>
      <div className="energy-display">
        <span className="energy-label">{t('energy.label')}</span>
        <span className="energy-pips">
          {Array.from({ length: ENERGY_MAX }, (_, i) => (
            <span key={i} className={`energy-pip${i < energy ? ' full' : ''}`}>●</span>
          ))}
        </span>
      </div>
      <button className="leaderboard-btn" onClick={() => window.location.search = '?leaderboard'}>
        🏆
      </button>
      <LanguageToggle />
    </div>
  );
};

export default TopBar;
